import React from "react";
import { ArcherContainer, ArcherElement } from "react-archer";

const sampleData = [
  {
    id: "corp",
    title: "Corporate HQ",
    description: "Global Strategy & Governance",
    imageUrl: "", // or actual image URL
    children: ["sales", "tech", "hr"],
  },
  {
    id: "sales",
    title: "Sales Division",
    description: "Revenue & Growth",
    imageUrl: "",
    children: ["sales-us", "sales-emea"],
  },
  {
    id: "tech",
    title: "Technology Division",
    description: "Engineering, Infra, Data",
    imageUrl: "",
    children: ["engineering", "data"],
  },
  {
    id: "hr",
    title: "HR Division",
    description: "People & Culture",
    imageUrl: "",
    children: [],
  },
  {
    id: "sales-us",
    title: "Sales – US",
    description: "North America accounts",
    imageUrl: "",
    children: [],
  },
  {
    id: "sales-emea",
    title: "Sales – EMEA",
    description: "Europe, Middle East",
    imageUrl: "",
    children: [],
  },
  {
    id: "engineering",
    title: "Engineering",
    description: "Platform & Products",
    imageUrl: "",
    children: [],
  },
  {
    id: "data",
    title: "Data & AI",
    description: "Analytics, Insights",
    imageUrl: "",
    children: [],
  },
];

const nodeMap = Object.fromEntries(sampleData.map((n) => [n.id, n]));

const AccountNodeCard = ({ node }) => (
  <div className="bg-white border border-orange-500 rounded-lg p-3 w-48 shadow text-center">
    {node.imageUrl ? (
      <img
        src={node.imageUrl}
        alt="node"
        className="w-12 h-12 mx-auto rounded-full mb-2"
      />
    ) : (
      <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-gray-300" />
    )}
    <div className="font-bold text-sm text-gray-800">{node.title}</div>
    <div className="text-xs text-gray-500">{node.description}</div>
  </div>
);

export default function EtAccountPlanVisualSample() {
  const renderLevel = (nodeIds) => (
    <div className="flex justify-center space-x-4 mb-10">
      {nodeIds.map((nodeId) => {
        const node = nodeMap[nodeId];
        return (
          <ArcherElement
            key={node.id}
            id={node.id}
            relations={
              node.children?.map((childId) => ({
                targetId: childId,
                targetAnchor: "top",
                sourceAnchor: "bottom",
              })) || []
            }
          >
            <div>
              <AccountNodeCard node={node} />
            </div>
          </ArcherElement>
        );
      })}
    </div>
  );

  return (
    <div className="bg-gray-100 p-6 font-poppins">
      <ArcherContainer strokeColor="orange" strokeWidth={2}>
        <div className="flex flex-col items-center space-y-2">
          {renderLevel(["corp"])}
          {renderLevel(["sales", "tech", "hr"])}
          {renderLevel(["sales-us", "sales-emea", "engineering", "data"])}
        </div>
      </ArcherContainer>
    </div>
  );
}